
let contactnum = $('.custom-wpcf7c-confirmed').length;
let contactnum_thanks = $('#thanks').length;


if(contactnum && !contactnum_thanks){
  $(".step1").removeClass('active');
  $(".step2"). addClass('active');
  $(".step3").removeClass('active');
} else if(!contactnum && contactnum_thanks) {
  $(".step1").removeClass('active');
  $(".step2"). removeClass('active');
  $(".step3").addClass('active');
}else {
  $(".step1"). addClass('active');
  $(".step2").removeClass('active');
  $(".step3"). removeClass('active');
}

$('.wpcf7c-elm-step1').click(function(){
  setInterval(function() {
    let contactnum = $('.custom-wpcf7c-confirmed').length;
    let contactnum_thanks = $('#thanks').length;
    if(contactnum && !contactnum_thanks){
      $(".step1").removeClass('active');
      $(".step2"). addClass('active');
      $(".step3").removeClass('active');
    } else if(!contactnum && contactnum_thanks) {
      $(".step1").removeClass('active');
      $(".step2"). removeClass('active');
      $(".step3").addClass('active');
    }else {
      $(".step1"). addClass('active');
      $(".step2").removeClass('active');
      $(".step3"). removeClass('active');
    }
  }, 300);
})

$('.wpcf7c-elm-step2').click(function(){
  $('.wpcf7-form').removeClass('custom-wpcf7c-confirmed');
  setInterval(function() {
    let contactnum = $('.custom-wpcf7c-confirmed').length;
    let contactnum_thanks = $('#thanks').length;
    if(contactnum && !contactnum_thanks){
      $(".step1").removeClass('active');
      $(".step2"). addClass('active');
      $(".step3").removeClass('active');
    } else if(!contactnum && contactnum_thanks) {
      $(".step1").removeClass('active');
      $(".step2"). removeClass('active');
      $(".step3").addClass('active');
    }else {
      $(".step1"). addClass('active');
      $(".step2").removeClass('active');
      $(".step3"). removeClass('active');
    }
  }, 300);
})

